export default {
  props: {
    goback: Object,
    queryData:Object
  },
  methods: {
    querylist() {
      let list = ''
      if (this.goback.type === '1') {
        list = ''
      } else {
        for (const k in this.queryData.query) {
          if (Object.hasOwnProperty.call(this.queryData.query, k)) {
           
            let value = this.queryData.query[k] !== undefined ? this.queryData.query[k] : '';
          
            list += `&${k}=${value.toString()}`;
          }
        }
      }
      
      
      return list 
    },
    chartClick() {
      const _that = this;
    
      if (_that.goback?.url) {
        this.myChart.on('click', function (params) {
          
          if (params.componentType === 'series') {
            let url = '';
            for (var k in _that.goback.params) {
              let value = _that.goback.params[k] !== undefined ? _that.goback.params[k] : '';
              url += `&${k}=${encodeURIComponent(params[value]).toString()}`;
            }
            let p;
            if (url === '') {
              p = _that.querylist() === '' ?"" : '?' + _that.querylist().substring(1)
            } else {
              const q =_that.querylist() === '' ?"" :  _that.querylist()
              p = '?' + url.substring(1) +q
            }
           
            if (_that.goback.target) {
              window.open(_that.goback.url + p);
            } else {
              window.location.href = _that.goback.url + p;            
            }
          }
        });
      }
      
    },
    scatterClick() {
      const _that = this;
      if (_that.goback?.url) {
        this.myChart.on('click', function (params) {
          if (params.componentType === 'series') {
            let url = '';
            for (var k in _that.goback.params) {
              let value = _that.goback.params[k] !== undefined ? _that.goback.params[k] : '';
           
              url += `&${k}=${encodeURIComponent(params[value])}`;
            }

            let p;
            if (url === '') {
              p = _that.querylist() === '' ?"" : '?' + _that.querylist().substring(1)
            } else {
              const q =_that.querylist() === '' ?"" :  _that.querylist()
              p = '?' + url.substring(1) +q
            }
         
            // window.location.href = _that.goback.url + p;
            if (_that.goback.target) {
              window.open(_that.goback.url + p);
            } else {
              window.location.href = _that.goback.url + p;            
            }
          }
        });
      }
    },
    // rectangleClick(n,v) {
    //   if (this.goback?.url) {
    //     const params = {
    //       name: n,
    //       value:v
    //     }
    //     let url = '';
    //     for (var k in this.goback.params) {
    //       let value = this.goback.params[k] !== undefined ? this.goback.params[k] : '';
     
    //       url += `&${k}=${encodeURIComponent(params[value])}`;
    //     }

       
    //     let p;
    //     if (url === '') {
    //       p = this.querylist() === '' ?"" : '?' + this.querylist().substring(1)
    //     } else {
    //       const q =this.querylist() === '' ?"" :  this.querylist()
    //       p = '?' + url.substring(1) +q
    //     }
        
    //     if (this.goback.target) {
    //       window.open(this.goback.url + p);
    //     } else {
    //       window.location.href = this.goback.url + p;            
    //     }
    //   }
    // },
    // flop2Click(prefixText, value) {
    //   if (this.goback?.url) {
    //     const params = {
    //       prefixText,
    //       value
    //     }
    //     let url = '';
    //     for (var k in this.goback.params) {
    //       let value = this.goback.params[k] !== undefined ? this.goback.params[k] : '';
   
    //       url += `&${k}=${encodeURIComponent(params[value])}`;
    //     }

    //     let p;
    //     if (url === '') {
    //       p = this.querylist() === '' ?"" : '?' + this.querylist().substring(1)
    //     } else {
    //       const q =this.querylist() === '' ?"" :  this.querylist()
    //       p = '?' + url.substring(1) +q
    //     }
        
    //     // window.location.href = this.goback.url + p;
    //     if (this.goback.target) {
    //       window.open(this.goback.url + p);
    //     } else {
    //       window.location.href = this.goback.url + p;            
    //     }
    //   }
    // },
    progressClick(params) {
      if (this.goback?.url) {
        // const params = {
        //   prefixText,
        //   value
        // }
        let url = '';
        for (var k in this.goback.params) {
          let value = this.goback.params[k] !== undefined ? this.goback.params[k] : '';
      
          url += `&${k}=${encodeURIComponent(params[value])}`;
        }

        let p;
        if (url === '') {
          p = this.querylist() === '' ?"" : '?' + this.querylist().substring(1)
        } else {
          const q =this.querylist() === '' ?"" :  this.querylist()
          p = '?' + url.substring(1) +q
        }
    
        if (this.goback.target) {
          window.open(this.goback.url + p);
        } else {
          window.location.href = this.goback.url + p;            
        }
      }
    },
    // pickupClick(n,i,port,c) {
    //   // node.label, node.id.npde.port, node.categories
    //   if (this.goback?.url) {
    //     const params = {
    //       label: n,
    //       id: i,
    //       port: port,
    //       categories:c
    //     }
    //     let url = '';
    //     for (var k in this.goback.params) {
    //       let value = this.goback.params[k] !== undefined ? this.goback.params[k] : '';
       
    //       url += `&${k}=${encodeURIComponent(params[value]).toString()}`;
    //     }

    //     let p;
    //     if (url === '') {
    //       p = this.querylist() === '' ?"" : '?' + this.querylist().substring(1)
    //     } else {
    //       const q =this.querylist() === '' ?"" :  this.querylist()
    //       p = '?' + url.substring(1) +q
    //     }
       
    //     if (this.goback.target) {
    //       window.open(this.goback.url + p);
    //     } else {
    //       window.location.href = this.goback.url + p;            
    //     }
    //   }
    // },
    imgClick() {
      if (this.goback?.url) {
       
        let url = '';
        for (var k in this.goback.params) {
          let value = this.goback.params[k] !== undefined ? this.goback.params[k] : '';
        
          url += `&${k}=${encodeURIComponent(value)}`;
        }

        let p;
        if (url === '') {
          p = this.querylist() === '' ?"" : '?' + this.querylist().substring(1)
        } else {
          const q =this.querylist() === '' ?"" :  this.querylist()
          p = '?' + url.substring(1) +q
        }
        
        if (this.goback.target) {
          window.open(this.goback.url + p);
        } else {
          window.location.href = this.goback.url + p;            
        }
      }
    },
    gobackClick() {
     
      if (this.goback?.url) {
        let url = '';
        for (var k in this.goback.params) {
          let value = this.goback.params[k] !== undefined ? this.goback.params[k] : '';
         
          url += `&${k}=${encodeURIComponent(value)}`;
        }

        let p;
        if (url === '') {
          p = this.querylist() === '' ?"" : '?' + this.querylist().substring(1)
        } else {
          const q =this.querylist() === '' ?"" :  this.querylist()
          p = '?' + url.substring(1) +q
        }
        
        if (this.goback.target) {
          window.open(this.goback.url + p);
        } else {
          window.location.href = this.goback.url + p;            
        }
      } else {
        window.history.back();
      }
    },
    tableClick(params) {
      if (this.goback?.url) {
        let url = ''
        if (this.goback?.isParameter) {
          url = '&' + params.name + '=' + params.value;
        }
      
        let p;
        if (url === '') {
          p = this.querylist() === '' ?"" : '?' + this.querylist().substring(1)
        } else {
          const q =this.querylist() === '' ?"" :  '&'+this.querylist()
          p = '?' + url.substring(1) + q
        }
      
        if (this.goback.target) {
          window.open(this.goback.url + p);
        } else {
          window.location.href = this.goback.url + p;            
        }
        
      }
    }
  },
}